import { handleToken, notifyBy } from './helper'
import { baseDec } from '@/composables/utilities/general'

class Http {
  get(url: string, queryParams: Record<string, any> = {}, options = {}) {
    return this.request(url, {
      method: 'GET',
      query: queryParams,
      ...options,
    })
  }

  post(url: string, body: any, options = {}) {
    return this.request(url, { method: 'POST', body, ...options })
  }

  put(url: string, body: any, options = {}) {
    return this.request(url, { method: 'PUT', body, ...options })
  }

  delete(url: string, options = {}) {
    return this.request(url, { method: 'DELETE', ...options })
  }

  request(url: string, options: any = {}) {
    const config = useRuntimeConfig()
    const userSessionId = localStorage.getItem('user-session-id')
    const Authorization = import.meta.client ? (localStorage.getItem('auth-token') as string) : ''
    const baseURL = config.public.apiUrl
    return new Promise((resolve, reject) => {
      $fetch(url, {
        ...options,
        baseURL,
        headers: {
          'pragma-cache-local': baseDec(userSessionId as string),
          Authorization,
          ...(options.headers || {}),
        },
        watch: false,

        onRequest() {
          handleToken()
        },

        onRequestError() {},

        async onResponse({ response }: any) {
          const token = response?._data?.payload?.auth_token
          token && localStorage.setItem('auth-token', token)
          notifyBy(response?._data)
        },

        onResponseError() {},
      })
        .then((response) => {
          resolve(response)
        })
        .catch(({ message }: any) => {
          reject(message)
        })
        .finally(() => {})
    })
  }
}
const $http = new Http()
export { $http }
